// TicketManager.js
import React, { useEffect, useState } from "react";
import {
  Button, TextField, Typography, Grid, Paper, IconButton,
} from "@mui/material";
import { db } from "../../firebase";
import { collection, addDoc, getDocs, deleteDoc, doc } from "firebase/firestore";
import DeleteIcon from "@mui/icons-material/Delete";
import { useParams } from "react-router-dom";

const TicketManager = () => {
    const { eventID } = useParams();
  const [ticketType, setTicketType] = useState("");
  const [price, setPrice] = useState("");
  const [quantity, setQuantity] = useState("");
  const [ticketList, setTicketList] = useState([]);

  useEffect(() => {
    fetchTickets();
  }, []);

  const fetchTickets = async () => {
    if (!eventID) return console.error("No eventID provided" + eventID + "!");
    const snapshot = await getDocs(collection(db, "events", eventID, "tickets"));
    const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    setTicketList(data);
  };

  const handleAdd = async () => {
    await addDoc(collection(db, "events", eventID, "tickets"), {
      ticketType,
      price: parseFloat(price),
      quantity: parseInt(quantity),
    });
    setTicketType("");
    setPrice("");
    setQuantity("");
    fetchTickets();
  };

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, "events", eventID, "tickets", id));
    fetchTickets();
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6">Manage Ticket Types</Typography>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={4}>
          <TextField
            fullWidth
            label="Ticket Type"
            value={ticketType}
            onChange={(e) => setTicketType(e.target.value)}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            fullWidth
            label="Price"
            type="number"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            fullWidth
            label="Quantity"
            type="number"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
          />
        </Grid>
        <Grid item xs={2}>
          <Button variant="contained" onClick={handleAdd}>
            Add
          </Button>
        </Grid>
      </Grid>

      <Typography variant="subtitle1" sx={{ mt: 4 }}>Current Tickets:</Typography>
      {ticketList.map((ticket) => (
        <Grid container key={ticket.id} sx={{ mt: 1 }}>
          <Grid item xs={4}>{ticket.ticketType}</Grid>
          <Grid item xs={3}>${ticket.price}</Grid>
          <Grid item xs={3}>Qty: {ticket.quantity}</Grid>
          <Grid item xs={2}>
            <IconButton onClick={() => handleDelete(ticket.id)}>
              <DeleteIcon />
            </IconButton>
          </Grid>
        </Grid>
      ))}
    </Paper>
  );
};

export default TicketManager;
